export default "__VITE_ASSET__89379b65__"